import breakpoints from '@/theme/constants/breakpoints';
import scrollbar from '@/theme/elements/scrollbar';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledProductFeed = styled.div``;

export const StyledHeader = styled.div`
  display: grid;
  grid-template-areas: 'header link' 'description .';
  grid-template-columns: 1fr max-content;
  grid-template-rows: repeat(2, auto);

  h2 {
    grid-area: header;
    ${typography.Section}
  }

  p {
    grid-area: description;
  }

  a {
    grid-area: link;
    margin: auto 0;
  }
`;

export const StyledCardGridList = styled.ul`
  width: 100%;
  box-sizing: content-box;
  gap: ${sizePx(8)};
  display: flex;
  align-self: flex-start;
  overflow-x: scroll;
  margin-left: -${sizePx(8)};
  margin-bottom: -${sizePx(8)};
  padding: ${sizePx(8)};
  list-style: none;
  ${scrollbar.hide}

  li > div {
    width: 300px;
    flex-shrink: 0;
  }

  @media only screen and ${breakpoints.device.m} {
    gap: ${sizePx(12)};
    margin-top: ${sizePx(2)};
  }

  @media only screen and ${breakpoints.device.l} {
    align-self: unset;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: 1fr;
    padding: 0;
    margin-top: ${sizePx(12)};
    margin-bottom: unset;
    margin-left: 0;
    overflow: visible;

    li > div {
      width: initial;
    }
  }
`;
